import { useIsSubscribed } from '#pplx/frontend/auth/useIsSubscribed.js';
import { useIsInternalUser } from '#pplx/frontend/auth/userHooks.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { useWebPlatform } from '#pplx/frontend/platform-components/useWebPlatform.js';
export function useSidebarInternalSettingsMenu() {
    const isInternalUser = useIsInternalUser();
    const { hasAccessToProFeatures } = useIsSubscribed();
    const { status } = useSession();
    const { env: { isDevDeployment, isLocalhost, isTesting }, } = useWebPlatform();
    const canLoadTestingBillingShortcutMenu = !hasAccessToProFeatures &&
        status === 'authenticated' &&
        (isLocalhost || isTesting || isDevDeployment);
    return {
        canLoadMenu: isInternalUser || canLoadTestingBillingShortcutMenu,
        showInternalDebugItems: isInternalUser,
        hasAccessToProFeatures,
    };
}
//# sourceMappingURL=useSidebarInternalSettingsMenu.js.map